import React from 'react';
import { NavigationButton } from './NavigationButton';
import { CalendarTitle } from './CalendarTitle';
import { Button } from '@components/atoms/Button';

interface CalendarHeaderProps {
  title: string;
  onPrevClick: () => void;
  onNextClick: () => void;
  onTitleClick?: () => void;
  prevDisabled?: boolean;
  nextDisabled?: boolean;
  onTodayClick?: () => void;
  className?: string;
  /** Prev/next arrows. Hidden in the Project view, where the whole range is already rendered. */
  showNavigation?: boolean;
  // Date range controls
  startDate?: string | null;
  endDate?: string | null;
  onStartDateChange?: (date: string) => void;
  onEndDateChange?: (date: string) => void;
  onClearRange?: () => void;
}

export const CalendarHeader: React.FC<CalendarHeaderProps> = ({
  title,
  onPrevClick,
  onNextClick,
  onTitleClick,
  onTodayClick,
  prevDisabled = false,
  nextDisabled = false,
  className = '',
  showNavigation = true,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  onClearRange,
}) => {
  return (
    <div className={`bg-white border-b border-gray-200 ${className}`}>
      {/* Main navigation row. flex-wrap so the date pickers drop to a second
          line when the viewport gets narrow instead of overflowing
          horizontally. */}
      <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-3 p-4">
        <div className="flex items-center gap-4">
          {showNavigation && (
            <NavigationButton
              direction="prev"
              onClick={onPrevClick}
              disabled={prevDisabled}
            />
          )}

          <CalendarTitle title={title || 'Loading...'} onClick={onTitleClick} />

          {showNavigation && (
            <NavigationButton
              direction="next"
              onClick={onNextClick}
              disabled={nextDisabled}
            />
          )}

          <Button variant="primary" onClick={onTodayClick}>
            Today
          </Button>
        </div>
        {/* Date range controls */}
        {(onStartDateChange || onEndDateChange || onClearRange) && (
          <div className="flex items-center justify-center gap-4">
            <div className="flex items-center gap-2">
              <label className="text-sm font-medium text-gray-700">
                Start Date:
              </label>
              <input
                type="date"
                value={startDate || ''}
                onChange={(e) => onStartDateChange?.(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <div className="flex items-center gap-2">
              <label className="text-sm font-medium text-gray-700">
                End Date:
              </label>
              <input
                type="date"
                value={endDate || ''}
                onChange={(e) => onEndDateChange?.(e.target.value)}
                className="px-3 py-1 border border-gray-300 rounded text-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
              />
            </div>

            <Button variant="secondary" size="md" onClick={onClearRange}>
              Clear Range
            </Button>
          </div>
        )}
      </div>
    </div>
  );
};
